function toYyyyMmDdFromUnixTimestamp(timestamp) {
  const date = new Date(Number(timestamp) * 1000);
  const year = date.getUTCFullYear();
  const month = `${date.getUTCMonth() + 1}`.padStart(2, "0");
  const day = `${date.getUTCDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function normalizeChartPoint(point) {
  return {
    time: toYyyyMmDdFromUnixTimestamp(point.timestamp),
    value: Number(point.value)
  };
}

function normalizeSeries(series, fallbackLabel) {
  const plot = Array.isArray(series?.plot) ? series.plot : [];

  return {
    label: series?.label || fallbackLabel,
    rateOfReturn: Number(series?.rate_of_return ?? 0),
    chart: plot.map(normalizeChartPoint)
  };
}

function normalizeComparison(comparison) {
  const key = comparison?.key || "comparison";

  return {
    key,
    ...normalizeSeries(comparison, key)
  };
}

function adaptComparisons(data) {
  if (Array.isArray(data.comparisons)) {
    return data.comparisons.map(normalizeComparison);
  }

  return Object.keys(data)
    .filter(key => key !== "strategy" && key !== "comparisons")
    .map(key => ({
      key,
      ...normalizeSeries(data[key], key)
    }));
}

export default function adaptStrategyBenchmarkChartData(rawData) {
  const data = rawData || {};

  return {
    strategy: normalizeSeries(data.strategy, "strategy"),
    comparisons: adaptComparisons(data)
  };
}
